import React from "react";
import { ModalType, useModal } from "../../stores/modalStore";
import { DownloadAppModal } from "./DownloadAppModal";

export const GlobalModalManager: React.FC = () => {
  const { modal } = useModal();

  return <>{modal === ModalType.DOWNLOAD_APP && <DownloadAppModal />}</>;
};
